import { AlertTriangle, Clock, DollarSign, Users, Info, Shield } from "lucide-react";

var ALERT_ICONS = {
  commission_blocked: DollarSign,
  payment_overdue: AlertTriangle,
  payment_upcoming: Clock,
  lead_stale: Users,
  commission_pending_old: Info,
  policy_expiring: Shield,
};
var SEVERITY_CLS = {
  high: "border-red-200 bg-red-50",
  medium: "border-amber-200 bg-amber-50",
  low: "border-blue-200 bg-blue-50",
};
var SEVERITY_ICON_CLS = {
  high: "text-red-500 bg-red-100",
  medium: "text-amber-500 bg-amber-100",
  low: "text-blue-500 bg-blue-100",
};
var SEVERITY_LABELS = { high: "Alta", medium: "Media", low: "Baixa" };

export function AlertsPanel({ alerts, compact }) {
  if (!alerts || alerts.length === 0) {
    return (
      <div className={"rounded-xl border border-gray-100 p-4 text-center text-gray-400 text-sm " + (compact ? "" : "bg-white shadow-sm")} data-testid="alerts-panel">
        Nenhum alerta ativo
      </div>
    );
  }

  return (
    <div className={compact ? "" : "bg-white rounded-xl p-4 shadow-sm border border-gray-100"} data-testid="alerts-panel">
      {!compact && (
        <div className="flex items-center gap-2 mb-4">
          <AlertTriangle className="w-5 h-5 text-amber-500" />
          <h4 className="text-sm font-semibold text-[#0A2F3D]">Alertas Ativos ({alerts.length})</h4>
        </div>
      )}
      <div className="space-y-2">
        {alerts.map(function(alert, idx) {
          var Icon = ALERT_ICONS[alert.type] || Info;
          var severityCls = SEVERITY_CLS[alert.severity] || SEVERITY_CLS.low;
          var iconCls = SEVERITY_ICON_CLS[alert.severity] || SEVERITY_ICON_CLS.low;
          return (
            <div key={idx} className={"flex items-start gap-3 p-3 rounded-xl border " + severityCls} data-testid={"alert-item-" + idx}>
              <div className={"p-1.5 rounded-lg flex-shrink-0 " + iconCls}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <p className="text-xs font-semibold text-gray-800">{alert.title}</p>
                  <span className={"px-1.5 py-0.5 rounded text-[10px] font-medium " + iconCls}>{SEVERITY_LABELS[alert.severity]}</span>
                </div>
                <p className="text-xs text-gray-600">{alert.message}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AlertsPanel;
